import { render, staticRenderFns } from "./WarehouseDashboard.vue?vue&type=template&id=4f15ae02&scoped=true&"
import script from "./WarehouseDashboard.vue?vue&type=script&lang=js&"
export * from "./WarehouseDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f15ae02",
  null
  
)

export default component.exports